import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

const StyledSpan = styled.span`
  font-size: ${rem(18)};

  & > span {
    display: inline-block;

    & + span {
      margin-left: 0.2em;
    }
  }

  & > span:nth-child(2) {
    font-size: 0.9em;
  }

  & > span:nth-child(3) {
    font-size: 0.8em;
  }
`;

const FontSizeIcon = () => {
  const char = 'A';
  const repeater = (new Array(3)).fill('x');
  return (
    <StyledSpan>
      {
        repeater.map((fill, i) => (
          <span key={i}>
            {char}
          </span>
        ))
      }
    </StyledSpan>
  );
};

export default FontSizeIcon;



// WEBPACK FOOTER //
// ./src/modules/Header/components/FontSizeMenu/components/FontSizeIcon.jsx